import { EVENT_CONVERSION } from '~~/constants/googleTagManager';

export const buildConversionTags = ({
  userToken,
  index,
  objectIDs,
  searchTerm,
}: {
  userToken?: string,
  index: string,
  objectIDs: string[],
  searchTerm: string,
}) => ({
  event: EVENT_CONVERSION,
  userToken,
  index,
  objectIDs,
  searchTerm,
});
